import React from "react"

import { LinkedAttachmentEntity } from "entities/attachments/ui/linked-attachments/types/LinkedAttachmentEntity"

import { DeleteAttachmentOverlayPayload } from "./DeleteAttachmentOverlayConnector"
import { DeleteAttachmentOverlayView } from "./DeleteAttachmentOverlayView"
import { useDeleteAttachmentOverlayViewModel } from "./model/useDeleteAttachmentOverlayViewModel"

export interface DeleteAttachmentOverlayModel {
  payload: DeleteAttachmentOverlayPayload
  linkedEntities: LinkedAttachmentEntity[] | null | undefined
  onDelete: () => void
  onClose: () => void
}

export const DeleteAttachmentOverlay = React.memo(
  (props: DeleteAttachmentOverlayModel) => (
    <DeleteAttachmentOverlayView
      {...useDeleteAttachmentOverlayViewModel(props)}
    />
  )
)
